<div class="row">
    <div class="col-lg-12">
        <div class="main-box clearfix">
            <div class="main-box-body clearfix">
                <h3 class="text-danger text-center" style="border-bottom:0"
                    *ngIf="!isActivePlanExists && stepFourNextClicked">* Please Choose a
                    Plan</h3>
                <!-- current plan -->
                <div class="row" style="margin-top:20px; padding: 20px; border: 1px solid lightgrey; "
                    *ngIf="isActivePlanExists && savedCurrentActivePlan.planHeaderDto">
                    <h2 class="text-center">Current Plan :
                        {{savedCurrentActivePlanName}}</h2>
                    <div class="non-editable-trial-plan-details" style="margin-top:20px" *ngIf="plans && plans[0]?.enabled">
                        <div class="col-xs-12">
                            <div class="col-xs-4">
                                <div class="col-xs-4">
                                    <label for="planType" class="control-label">Plan
                                        Type: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <input type="text" name="planType" id="planType"
                                        [ngModel]="savedCurrentActivePlan.planHeaderDto.planType"
                                        class="form-control" disabled style="position: relative;bottom: 10px;">
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective Start
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{savedCurrentActivePlan.planHeaderDto.planStartDateDisplay}}
                                    ({{savedCurrentActivePlan.planHeaderDto.timeZoneName}})
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective End
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{savedCurrentActivePlan.planHeaderDto.planEndDateDisplay}}
                                    ({{savedCurrentActivePlan.planHeaderDto.timeZoneName}})
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12" style="margin-top:20px">
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="assessmentAllocated" class="control-label">Assessments Allocated:
                                    </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{savedCurrentActivePlan.planDetailDto.taAllocated}}</span>
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="assessmentUsed" class="control-label">Assessments
                                        Used: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{savedCurrentActivePlan.planDetailDto.taUsed}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12" style="margin-top:20px">
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="jobBoardsResumesAllocated" class="control-label">Job Boards Resumes
                                        Allocated: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{savedCurrentActivePlan.planDetailDto.jbiAllocated}}</span>
                                </div>
                            </div>

                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="jobBoardsResumesPulled" class="control-label">Job Boards Resumes
                                        Pulled: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{savedCurrentActivePlan.planDetailDto.jbiUsed}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="non-editable-non-trial-plan-details" style="margin-top:20px"
                        *ngIf="!(plans && plans[0]?.enabled)">
                        <div class="col-xs-12">
                            <div class="col-xs-4">
                                <div class="col-xs-4">
                                    <label for="planType" class="control-label">Plan
                                        Type: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <input type="text" name="planType" id="planType"
                                        [ngModel]="savedCurrentActivePlan.planHeaderDto.planType"
                                        class="form-control" disabled style="position: relative;bottom: 10px;">
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective Start
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{savedCurrentActivePlan.planHeaderDto.planStartDateDisplay}}
                                    ({{savedCurrentActivePlan.planHeaderDto.timeZoneName}})
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective End
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{savedCurrentActivePlan.planHeaderDto.planEndDateDisplay}}
                                    ({{savedCurrentActivePlan.planHeaderDto.timeZoneName}})
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12" style="margin-top:20px"
                            *ngIf="savedCurrentActivePlanName !== 'Vendor Only'">
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="assessmentsUsed" class="control-label">Assessments
                                        Used: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{savedCurrentActivePlan.planDetailDto.taUsed}}</span>
                                </div>
                            </div>

                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="jobBoardsResumesPulled" class="control-label">Job Boards Resumes
                                        Pulled: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{savedCurrentActivePlan.planDetailDto.jbiUsed}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- future plan -->
                <div class="row" *ngIf="isFuturePlanExists && savedCurrentActivePlanName != futurePlanName"
                    [ngClass]="{'upgraded-plan': savedFuturePlanPriority > savedCurrentActivePlanPriority, 'downgraded-plan': savedFuturePlanPriority < savedCurrentActivePlanPriority }">
                    <h2 class="text-center">Next Plan : {{futurePlanName}}
                        <span *ngIf="savedFuturePlanPriority > savedCurrentActivePlanPriority"><i
                                class="fa fa-arrow-circle-up"></i></span>
                        <span *ngIf="savedFuturePlanPriority < savedCurrentActivePlanPriority"><i
                                class="fa fa-arrow-circle-down"></i></span>
                    </h2>
                    <div class="non-editable-future-plan-details" style="margin-top:20px">
                        <div class="col-xs-12">
                            <div class="col-xs-4">
                                <div class="col-xs-4">
                                    <label for="planType" class="control-label">Plan
                                        Type: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <input type="text" name="planType" id="planType"
                                        [ngModel]="futurePlan.planHeaderDto.planType" class="form-control" disabled
                                        style="position: relative;bottom: 10px;">
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective Start
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{futurePlan.planHeaderDto.planStartDateDisplay}}
                                    ({{futurePlan.planHeaderDto.timeZoneName}})
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective End
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{futurePlan.planHeaderDto.planEndDateDisplay}}
                                    {{futurePlan.planHeaderDto.timeZoneName}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- expired plan-->
                <div class="row downgraded-plan" style="margin-top:20px; padding: 20px;" *ngIf="expiredPlan">
                    <h2 class="text-center">Expired Plan :
                        {{expiredPlan.planHeaderDto.planName}}</h2>
                    <div class="non-editable-trial-plan-details" style="margin-top:20px" *ngIf="plans && plans[0]?.enabled">
                        <div class="col-xs-12">
                            <div class="col-xs-4">
                                <div class="col-xs-4">
                                    <label for="planType" class="control-label">Plan
                                        Type: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <input type="text" name="planType" id="planType"
                                        [ngModel]="expiredPlan.planHeaderDto.planType" class="form-control" disabled
                                        style="position: relative;bottom: 10px;">
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective Start
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{expiredPlan.planHeaderDto.planStartDateDisplay}}
                                    ({{expiredPlan.planHeaderDto.timeZoneName}})
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective End
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{expiredPlan.planHeaderDto.planEndDateDisplay}}
                                    ({{expiredPlan.planHeaderDto.timeZoneName}})
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12" style="margin-top:20px">
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="assessmentAllocated" class="control-label">Assessments Allocated:
                                    </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{expiredPlan.planDetailDto.taAllocated}}</span>
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="assessmentUsed" class="control-label">Assessments
                                        Used: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{expiredPlan.planDetailDto.taUsed}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12" style="margin-top:20px">
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="jobBoardsResumesAllocated" class="control-label">Job Boards Resumes
                                        Allocated: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{expiredPlan.planDetailDto.jbiAllocated}}</span>
                                </div>
                            </div>

                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="jobBoardsResumesPulled" class="control-label">Job Boards Resumes
                                        Pulled: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{expiredPlan.planDetailDto.jbiUsed}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="non-editable-non-trial-plan-details" style="margin-top:20px"
                        *ngIf="!(plans && plans[0]?.enabled)">
                        <div class="col-xs-12">
                            <div class="col-xs-4">
                                <div class="col-xs-4">
                                    <label for="planType" class="control-label">Plan
                                        Type: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <input type="text" name="planType" id="planType"
                                        [ngModel]="expiredPlan.planHeaderDto.planType" class="form-control" disabled
                                        style="position: relative;bottom: 10px;">
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective Start
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{expiredPlan.planHeaderDto.planStartDateDisplay}}
                                </div>
                            </div>
                            <div class="col-xs-4">
                                <div class="col-xs-5">
                                    <label class="control-label">Effective End
                                        Date: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    {{expiredPlan.planHeaderDto.planEndDateDisplay}}
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12" style="margin-top:20px" *ngIf="expiredPlanName !== 'Vendor Only'">
                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="assessmentsUsed" class="control-label">Assessments
                                        Used: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{expiredPlan.planDetailDto.taUsed}}</span>
                                </div>
                            </div>

                            <div class="col-xs-4">
                                <div class="col-xs-6">
                                    <label for="jobBoardsResumesPulled" class="control-label">Job Boards Resumes
                                        Pulled: </label>
                                </div>
                                <div class="col-xs-6 pull-right">
                                    <span>{{expiredPlan.planDetailDto.jbiUsed}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="companyManagement.company.companyType == 'StaffingCompany'"
                    class="row slider-icons-container">
                    <span (click)="onSlideClick('left')" style="margin-right:auto"><i
                            class="fa fa-angle-double-left slider-icon"></i></span>
                    <span (click)="onSlideClick('right')"><i
                            class="fa fa-angle-double-right slider-icon"></i></span>
                </div>
                <div class="plans-container" id="content"
                    [ngClass]="{'justify-content-center': companyManagement.company.companyType == 'Corporation'}">
                    <div class=" pricing-package plan-content" *ngFor="let plan of plans; let i = index">
                        <div class="pricing-package-inner pricing-card"
                            [ngClass]="{'selected-plan': plan.enabled == true}">
                            <div class="package-header"
                                [ngClass]="{'green-bg': i == 1, 'yellow-bg': i == 2, 'purple-bg': i == 3}">
                                <span class="stars mx-auto">
                                    <i class="fa fa-star"></i>
                                </span>
                                <h3>{{plan.plan}}</h3>
                            </div>
                            <div class="package-content">
                                <div class="package-price"
                                    [ngClass]="{'green-bg': i == 1, 'yellow-bg': i == 2, 'purple-bg': i == 3}">
                                    <span class="currency"
                                        *ngIf="plan.plan != 'Trial' && plan.plan != 'Vendor Only'">$</span>
                                    <span class="price">{{plan.planCost}}</span>
                                    <span class="package-month"
                                        *ngIf="plan.plan != 'Trial' && plan.plan != 'Vendor Only'">/user/month</span>
                                </div>
                                <ul class="package-top-features">
                                    <li *ngFor="let feature of plan.features | slice:0:4">
                                        <span>{{feature.displayName}}</span>
                                        <span
                                            *ngIf="feature.additionalInfo.length>0">({{feature.additionalInfo}})</span>
                                    </li>
                                </ul>
                                <ul class="package-features">
                                    <li [ngClass]="{'has-feature': feature.available, 'has-nofeature': !feature.available}"
                                        *ngFor="let feature of plan.features | slice:(4 - plan.features.length)">
                                        <span
                                            *ngIf="feature.limited && feature.name =='Tech Assessments'">{{feature.limitValue}}</span>
                                        <span>{{feature.displayName}}</span>
                                        <span
                                            *ngIf="feature.additionalInfo.length>0">({{feature.additionalInfo}})</span>
                                        <span *ngIf="feature.limited && feature.name!='Tech Assessments'">(Limited
                                            to {{feature.limitValue}})</span>
                                    </li>
                                </ul>
                                <div class="package-footer">
                                    <button
                                        [ngClass]="{'hide-plan-button':(isActivePlanExists && !plan.enabled && plan.plan == 'Trial' && savedCurrentActivePlanName !== 'Vendor Only') || hidePlanActionButtonsForRole || !plan.isPlanAvailable,'btn btn-secondary': plan.enabled, 'btn btn-primary': !plan.enabled}"
                                        (click)="choosePlan(i)">
                                        <span>{{plan.planActionText}}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
